module.exports = __webpack_public_path__ + "media/images/icons/cross-ecc6ad7978c5947fa8825e639c716813.svg";